import type { TableColumn } from "../types";

/**
 * Determines the CSS color class based on numeric value and inversion setting
 *
 * @param value - The numeric value to evaluate
 * @param inverted - When true, positive values are shown as negative and vice versa
 * @returns CSS class name for text color
 */
export const valueColor = (
	value: number | undefined,
	inverted?: boolean,
): string => {
	if (!value) return "text-light-gray";

	const shouldBeNegative = inverted ? value > 0 : value < 0;

	return shouldBeNegative ? "text-error-light" : "text-success-light";
};

export const sortedByDateAndType = (ee?: TableColumn[]) => {
	return ee?.sort(compare);
};
const compare = (a: TableColumn, b: TableColumn) => {
	if (a.type < b.type) {
		return 1;
	}
	if (a.type > b.type) {
		return -1;
	}
	if (a.year > b.year) {
		return 1;
	}
	if (a.year < b.year) {
		return -1;
	}
	if (a.quarter === undefined || b.quarter === undefined) {
		return 0;
	}
	if (a.quarter > b.quarter) {
		return 1;
	}
	if (a.quarter < b.quarter) {
		return -1;
	}
	return 0;
};
